import React from "react";

import { CButton } from "@coreui/react";
import { useHttp } from "../hooks/useHttp";
import { useMutation } from "@tanstack/react-query";

import Popup from "../components/Popup";
import openToast from "../utils/sweetAlert";

const PopupSoares = props => {
  const { trigger, setTrigger, chat } = props;

  const request = useHttp();

  const soaresMutation = useMutation(["send-phone-soares"], () => request({ url: `/users/send/phone/${chat.user_id}`, method: "POST", data: {} }), {
    onSuccess: res => {
      if (res.data.error) {
        openToast("error", "Ocorreu um erro", res.data.message);
      }

      if (!res.data.error) {
        openToast("success", "Sucesso", res.data.message);
        setTrigger(false);
      }
    }
  });

  return (
    <Popup title="Enviar número para o Soares" trigger={trigger} setTrigger={setTrigger} width="420">
      <div className="x-p-20">
        <div className="text-color mt-10">
          Tem certeza que deseja enviar o número do cliente atual para o Soares?
        </div>

        <div className="d-flex flex-row justify-content-between mt-20 mb-20">
          <div></div>
          <div>
            <CButton color="danger" variant="ghost" onClick={() => setTrigger(false)}>Cancelar</CButton>
            <CButton type="submit" color="primary" className="ml-10" onClick={() => soaresMutation.mutate()}>
              {soaresMutation.isLoading ? "Enviando..." : "Sim, enviar"}
            </CButton>
          </div>
        </div>
      </div>
    </Popup>
  );
}

export default PopupSoares;